import {TemplatePortal} from '@angular/cdk/portal';
import {ChangeDetectionStrategy, Component, TemplateRef, ViewContainerRef} from '@angular/core';
import {FormBuilder, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {InputPasswordComponent} from 'src/app/shared/components/inputs/input-password/input-password.component';
import {InputTextComponent} from 'src/app/shared/components/inputs/input-text/input-text.component';
import {SidenavComponent} from 'src/app/layout/sidenav/sidenav.component';
import {SidenavService} from 'src/app/core/services/sidenav.service';
import {confirmPasswordValidator} from 'src/app/shared/validators/confirm-password.validator';
import {PrimaryButtonComponent} from '../../buttons/primary-button/primary-button.component';

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    SidenavComponent,
    InputTextComponent,
    InputPasswordComponent,
    PrimaryButtonComponent,
  ]
})
export class SignUpComponent {
  signupForm = this.fb.group({
    username: ['', [Validators.required]],
    email: ['', [Validators.required, Validators.email]],
    password: ['', Validators.required],
    passwordMatch: ['', [Validators.required, confirmPasswordValidator('password', 'passwordMatch')]],
  });

  constructor(
    private readonly sidenavService: SidenavService,
    private vcf: ViewContainerRef,
    private readonly fb: FormBuilder
  ) {
  }

  openRightPanel(templateRef: TemplateRef<any>) {
    const portal = new TemplatePortal(templateRef, this.vcf);
    this.sidenavService.open(portal, 'end', 'normal');
  }

  public onSignupClick() {
    window.alert('please implement this function!');
    //accountService.signup(this.signupForm.value)
  }
}
